import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import logo from '../../assets/aba/logo-aba.png'
import ginTonic from '../../assets/cocktails/ginTonic.jpg'
import atonic from '../../assets/cocktails/atonic.jpg'
import vermut from '../../assets/cocktails/vermut.jpg'
import Modal from 'react-bootstrap/Modal';
import { useState } from 'react';
import { ListGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next'


const cocktailsContainer = {
    fontSize: '20px',
    textAlign: 'center',
    alignContent: 'center',
    marginTop: '20px'
};


function Cocktails() {

  const [showCocktail1, setShowCocktail1] = useState(false);
  const [showCocktail2, setShowCocktail2] = useState(false);
  const [showCocktail3, setShowCocktail3] = useState(false);

  const handleCloseCocktail1 = () => setShowCocktail1(false);
  const handleShowCoctail1 = () => setShowCocktail1(true);

  const handleCloseCocktail2 = () => setShowCocktail2(false);
  const handleShowCoctail2 = () => setShowCocktail2(true);

  const handleCloseCocktail3 = () => setShowCocktail3(false);
  const handleShowCoctail3 = () => setShowCocktail3(true);

   const { i18n, t } = useTranslation();


    return (
      <Container style={cocktailsContainer} fluid>
        <Row>
          <Col><h2>{t('cocktails')}</h2></Col> 
        </Row>
        <Row>
          <Col xs={12} md={4}>
            <Card style={{ width: '100%'}}>
            <Card.Img variant="top" src={ginTonic} />
            <Card.Body>
                <Card.Title>{t('GinTonic')}</Card.Title>
                    <Card.Text>
                      {t('ingredientsGinTonic')}
                    </Card.Text>
                    <Button variant="primary" onClick={handleShowCoctail1} >{t('btnReceipt')}</Button>
            </Card.Body>
            </Card>
          </Col>
          <Col xs={12} md={4}>
            <Card style={{ width: '100%' }}>
            <Card.Img variant="top" src={atonic} />
            <Card.Body>
                <Card.Title>{t('Atonik')}</Card.Title>
                    <Card.Text>
                      {t('ingredientsAtonik')}
                    </Card.Text>
                    <Button variant="primary" onClick={handleShowCoctail2} >{t('btnReceipt')}</Button>
            </Card.Body>
            </Card>
          </Col>
          <Col xs={12} md={4}>
            <Card style={{ width: '100%'}}>
            <Card.Img variant="top" src={vermut} />
            <Card.Body>
                <Card.Title>{t('Vermút')}</Card.Title>
                    <Card.Text>
                     {t('ingredientsVermut')}
                    </Card.Text>
                    <Button variant="primary" onClick={handleShowCoctail3} >{t('btnReceipt')}</Button>
            </Card.Body>
            </Card>
          </Col>
        </Row>


        {/* Modals Coctails */}
        <Modal show={showCocktail1} onHide={handleCloseCocktail1} aria-labelledby="contained-modal-title-vcenter">
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Gin Tonic
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="grid-example">
            <Container>
              <Row>
                <Col xs={12} md={8}>
                  <img
                    src={ginTonic}
                    width="100%"
                    height="100%"
                    className="d-inline-block align-top"
                    alt="Aba logo"
                  />
                </Col>
                <Col xs={12} md={4}>
                <Card>
                  <ListGroup variant="flush">
                    <ListGroup.Item>2 Oz de Gin Peregrino</ListGroup.Item>
                    <ListGroup.Item>Agua Tónica</ListGroup.Item>
                    <ListGroup.Item>Rodajas de Limón</ListGroup.Item>
                  </ListGroup>
                </Card>
                </Col>
              </Row>
              <hr/>
              <Row style={{ textAlign: 'center' }}>
                <Col xs={12} md={12}>
                <Card.Body>
                  <Card.Text>
                    <li>Llenar una copa por completo con hielo</li>
                    <li>Agregar 2 0z de Gin Peregrino </li>
                    <li>Completar con Agua Tónica</li>
                    <li>Agregar 1 Rodaja de Limón</li>
                  </Card.Text>
                </Card.Body>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleCloseCocktail1}>Cerrar</Button>
          </Modal.Footer>
        </Modal>
        {/* ----- */}
        <Modal show={showCocktail2} onHide={handleCloseCocktail2} aria-labelledby="contained-modal-title-vcenter">
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Atonic
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="grid-example">
            <Container>
            <Row>
                <Col xs={12} md={8}>
                  <img
                    src={atonic}
                    width="100%"
                    height="100%"
                    className="d-inline-block align-top"
                    alt="Aba logo"
                  />
                </Col>
                <Col xs={12} md={4}>
                <Card>
                  <ListGroup variant="flush">
                    <ListGroup.Item>2 Oz de Atónito</ListGroup.Item>
                    <ListGroup.Item>Agua Tónica</ListGroup.Item>
                    <ListGroup.Item>Rodajas de Naranja</ListGroup.Item>
                  </ListGroup>
                </Card>
                </Col>
              </Row>
              <hr/>
              <Row style={{ textAlign: 'center' }}>
                <Col xs={12} md={12}>
                <Card.Body>
                  <Card.Text>
                    <li>Llenar una copa por completo con hielo</li>
                    <li>Agregar 2 0z de Atónito </li>
                    <li>Completar con Agua Tónica</li>
                    <li>Agregar 1 Rodaja de Naranja</li>
                  </Card.Text>
                </Card.Body>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleCloseCocktail2}>Close</Button>
          </Modal.Footer>
        </Modal>
        {/* ------- */}
        <Modal show={showCocktail3} onHide={handleCloseCocktail3} aria-labelledby="contained-modal-title-vcenter">
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Vermút
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="grid-example">
            <Container>
            <Row>
                <Col xs={12} md={8}>
                  <img
                    src={vermut}
                    width="100%"
                    height="100%"
                    className="d-inline-block align-top"
                    alt="Aba logo"
                  />
                </Col>
                <Col xs={12} md={4}>
                <Card>
                  <ListGroup variant="flush">
                    <ListGroup.Item>2 Oz de Vermut Pais</ListGroup.Item>
                    <ListGroup.Item>Soda</ListGroup.Item>
                    <ListGroup.Item>Rodajas de Naranja</ListGroup.Item>
                  </ListGroup>
                </Card>
                </Col>
              </Row>
              <hr/>
              <Row style={{ textAlign: 'center' }}>
                <Col xs={12} md={12}>
                <Card.Body>
                  <Card.Text>
                    <li>Llenar una copa por completo con hielo</li>
                    <li>Agregar 2 0z de Vermut Pais </li>
                    <li>Completar Soda</li>
                    <li>Agregar 1 Rodaja de Naranja</li>
                  </Card.Text>
                </Card.Body>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleCloseCocktail3}>Close</Button>
          </Modal.Footer>
        </Modal>
      </Container>

      
    );
  }
  
  export default Cocktails;